import React from 'react';

interface IUserFormProps {
  user: any;
  team: any;
  setEditMode: any;
  cusId: string;
  createCustomerPortalSession: any;
  handleTabChange: any;
};

const UserLicensesForm: React.FC<IUserFormProps> = ({ handleTabChange, cusId, createCustomerPortalSession, team, user, setEditMode }) => {
  return (
    <></>
  );
};

export default UserLicensesForm;
